export const RESET_APP_STATE = 'RESET_APP_STATE';
